module.exports = "/fonts/fa-solid-900.svg?7726a281c1d436eb038f78c6e9048c96";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-solid-900.svg
// module id = Bzne
// module chunks = 0 1